import { Input } from "@/components/ui/input";

import { SearchIcon } from "./icons";

interface SearchInputProps {
  onSearch(query: string): void;
}

export default function SearchInput({ onSearch }: SearchInputProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    onSearch(event.currentTarget.value);

  return (
    <div className="container px-5">
      <div className="relative">
        <div className="absolute inset-y-0 left-0 flex w-10 items-center justify-center">
          <SearchIcon />
        </div>
        <Input
          aria-autocomplete="none"
          autoComplete="off"
          autoCorrect="off"
          className="h-10 rounded-[20px] border-0 bg-white/10 pl-10 text-white placeholder:text-white/50"
          onChange={handleChange}
          placeholder="Search"
          spellCheck="false"
          type="search"
        />
      </div>
    </div>
  );
}
